/**
 * Time of day greeting.
 *
 * Pure and given the hour rather than reading a clock, so the boundaries can
 * be tested rather than trusted.
 */
export function greetingForHour(hour: number): string {
  if (!Number.isFinite(hour)) return 'Welcome back';
  const h = Math.floor(hour);
  if (h < 5) return 'Still up';
  if (h < 12) return 'Good morning';
  if (h < 18) return 'Good afternoon';
  return 'Good evening';
}
